export const entityLevelEnum = {
  national: "National",
  club: "Club",
  football_club: "Football Club",
  football_Club: "Football Club",
  football_academy: "Football Academy",
  federation_entity: "Football Entity",
  sponsor_brand: "Sponsor Brand",
  professional_training_entity: "Professional Training Entity",
  university: "University",
  school: "School",
  other: "Other",
} as const;

export type EntityLevel = keyof typeof entityLevelEnum;

export const entityLevels = [
  "national",
  "club",
  "football_club",
  "football_Club",
  "football_academy",
  "federation_entity",
  "sponsor_brand",
  "professional_training_entity",
  "university",
  "school",
  "other",
] as const;
